import axios from "@/core/plugins/axios";
import store from '@/core/store'
import {HANDLE_ERRORS} from "@/core/store/modules/errors/constants";
import toast from "@/core/utils/toast";

axios.interceptors.response.use(
    function (response) {

        if (response && response.data && response.data.success && response.data.message) {
             toast.success(response.data.message)
         }

        return Promise.resolve(response);
    },
    function (error) {

        store.dispatch(HANDLE_ERRORS, {error})

        return Promise.reject(error)
    }
);

